import { lazy } from "react";
import { Navigate } from "react-router";
// import ApprovedClaims from "src/pages/admin/incentive1/programApproval/ApprovedClaims";
// import PendingClaims from "src/pages/admin/incentive1/programApproval/PendingClaims";

import Loadable from "src/routes/Loadable";

const IncentiveProgram = Loadable(
  lazy(() => import("src/pages/admin/incentive1/program"))
);

const ProgramApprovals = Loadable(
  lazy(() => import("src/pages/admin/incentive1/programApproval"))
);
const PendingClaims = Loadable(
  lazy(() => import("src/pages/admin/incentive1/programApproval/PendingClaims"))
);
const ApprovedClaims = Loadable(
  lazy(() => import("src/pages/admin/incentive1/programApproval/ApprovedClaims"))
);
const incentive = [
  {
    path: "incentive",
    children: [
      { element: <Navigate to="programs" />, index: true },
      { path: "programs", element: <IncentiveProgram /> },

      {
        path: "programapprovals",
        element: <ProgramApprovals />,
        children: [
          { element: <Navigate to="pending_claims" />, index: true },
          { path: "pending_claims", element: <PendingClaims /> },
          { path: "approved_claims", element: <ApprovedClaims /> },
        ],
      },
    ],
  },
];

export default incentive;
